module.exports = __webpack_public_path__ + "img/finance_piutang.50464e8b.svg";